


















// Composition
import { computed, defineComponent } from '@nuxtjs/composition-api'

// Types
import { ElasticFieldsInterface } from '@/types/search/elasticTypes'

// Common
import { decodeHTMLEntities, slugify } from '@/common/utils/characters'
import { getResourceHeading } from '@/common/utils/search'

// Composables
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'
import useSearch from '@/composables/search/useSearch'
import { useSearchStore } from '~/store'

export default defineComponent({
  name: 'ContentType',

  props: {
    fields: {
      required: true,
      type: Object as () => ElasticFieldsInterface,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    index: {
      required: true,
      type: Number,
    },
    score: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  setup(props) {
    const { trackResourceClick, trackSiteSearchEngagement } = useSearchAnalytics()
    const { getSearchResultUrl } = useSearch()
    const searchStore = useSearchStore()

    const stripBrand = (fields: ElasticFieldsInterface) => {
      if (fields.title === undefined) {
        return
      }
      const title = fields?.title?.raw.replace(' | Cell Signaling Technology', '')
      return decodeHTMLEntities(title)
    }

    const resourceHeading = computed(() => {
      if (props.fields.headings && props.fields.headings.raw[1]) {
        return getResourceHeading(props.fields)
      }
      return stripBrand(props.fields)
    })

    const onResourceClick = (fields: ElasticFieldsInterface) => {
      trackResourceClick(fields)

      trackSiteSearchEngagement({
        pages_number: searchStore.page?.currentPage,
        query_executed: searchStore.searchInput,
        results_per_page: searchStore.getResults.meta?.page?.size ?? 30,
        view_item_list_id: 'RRP',
        view_item_list_name: 'Resource Result Page',
        selected_item_list_name: 'Resource Result Page (RRP)',
        selected_result_destination: getSearchResultUrl(fields),
        selected_result_text: resourceHeading.value,
        filters: searchStore.facets.checkedFacets,
        selected_item_index: props.index,
      })
    }

    return {
      decodeHTMLEntities,
      slugify,
      getSearchResultUrl,
      resourceHeading,
      onResourceClick,
    }
  },
})
